import { render, staticRenderFns } from "./CorporationB.vue?vue&type=template&id=d072c3e6&scoped=true"
import script from "./CorporationB.vue?vue&type=script&lang=js"
export * from "./CorporationB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d072c3e6",
  null
  
)

export default component.exports